import React from "react";

function JoinWithUs() {
  return (
    <div>
      <div className="newsletter-area default-padding blurry-shape bg-dark text-light">
        <div className="container">
          <div className="row">
            <div className="py-5">
              <div className="newsletter-style-three text-center ">
                <h4 className="sub-title">Join with us</h4>
                <h2 className="title split-lines pt-3">
                  Stay Updated With Innovation
                </h2>
                <p>
                  Get insights on AI, Blockchain, Web3, Crypto Trends, and
                  Product Engineering.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JoinWithUs;
